export const baseurl = 'https://sak.smcg.bh/Backend/api/'
export const baseurImage = 'https://sak.smcg.bh/Backend/uploads/'
